import { z } from "zod";

export const OccupancyMonthRoomTypeSchema = z.object({
    filter: z.object({
        property_id: z.string().uuid(),
        start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid start date format (YYYY-MM-DD)"),
        end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid end date format (YYYY-MM-DD)"),
        room_type_id: z.string().optional(), // Bisa berupa string dengan ID yang dipisahkan koma jika diperlukan
    }),
}).refine(
    (data) => new Date(data.filter.end_date) >= new Date(data.filter.start_date),
    {
        message: "End date must be after or equal to start date",
        path: ["filter", "end_date"],
    }
);

export type OccupancyMonthRoomType = z.infer<typeof OccupancyMonthRoomTypeSchema>;
